
export const dateFormater = (date) => {
    const newDate = new Date(date);
    const options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' };
    return newDate.toLocaleDateString('ru-RU', options);
}
